import { render, staticRenderFns } from "./ProjectHeaderPure.vue?vue&type=template&id=6cdd02da&scoped=true&"
import script from "./ProjectHeaderPure.vue?vue&type=script&lang=ts&"
export * from "./ProjectHeaderPure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectHeaderPure.vue?vue&type=style&index=0&id=6cdd02da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd02da",
  null
  
)

export default component.exports